export const WEATHER_MAP_WIDGET_STACKED_MAX_WIDTH_PX = 560;

const getWidgetLayoutDimensions = (layout) => {
  const layoutMatch = String(layout ?? '')
    .trim()
    .match(/^(\d+)x(\d+)$/i);

  if (!layoutMatch) {
    return { columns: 1, rows: 1 };
  }

  const columns = Number(layoutMatch[1]);
  const rows = Number(layoutMatch[2]);

  return columns > 0 && rows > 0 ? { columns, rows } : { columns: 1, rows: 1 };
};

/**
 * Converts a dashboard span into one of the layouts supported by weather-map widgets.
 * Multi-row widgets stack their content, while wider single-row widgets place content
 * side by side unless the rendered widget cell is too narrow.
 *
 * @param {object} options - Values used to resolve the widget layout.
 * @param {string} options.layout - BaseWidget layout such as "1x1" or "2x1".
 * @param {number|null} [options.containerWidthPx] - Rendered widget-cell width.
 * @param {number} [options.stackedMaxWidthPx] - Width below which a wide layout stacks.
 * @returns {'1x1'|'1x2'|'2x1'} Canonical weather-map widget layout.
 */
export const resolveWeatherMapWidgetLayout = ({
  layout,
  containerWidthPx = null,
  stackedMaxWidthPx = WEATHER_MAP_WIDGET_STACKED_MAX_WIDTH_PX,
} = {}) => {
  const { columns, rows } = getWidgetLayoutDimensions(layout);
  const canonicalLayout = rows > 1 ? '1x2' : columns > 1 ? '2x1' : '1x1';
  const hasMeasuredContainerWidth = Number.isFinite(containerWidthPx) && containerWidthPx >= 0;
  const shouldStackWideLayout =
    canonicalLayout === '2x1' && hasMeasuredContainerWidth && containerWidthPx < stackedMaxWidthPx;

  return shouldStackWideLayout ? '1x2' : canonicalLayout;
};
